const SectionTitle = ({text, iconSrc, iconName, className}) =>
  <>
    {iconSrc ? <img src={iconSrc} alt=""/> : <></>}
    {iconName ? <span className={`d-block ${iconName} text-green text-32`}></span> : <></>}
    <h3 className={`m-0${(iconSrc || iconName) ? ' me-4' : ''} text-white text-24 font-weight-600 ${className || ''}`}>{text}</h3>
  </>

export default SectionTitle
